import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import AppCollapse from "components/ui/AppCollapse";
import AppButton from "components/ui/AppButton";
import AppIcon from "components/ui/AppIcon";
import { UTILS } from "utils";
import {
  useGetModifierGroupMutation,
  useGetModifierListMutation,
} from "redux/modifiers/service";

import AttachModifierModal from "./AttachModifierModal";
import ModifierDragger from "./ModiferRowDraggable";
// import ModifiersTable from "./ModifiersTable";
import UpdateModifierModal from "../../UpdateModifier";
import useGroupModifierApi from "../../useGroupModifierApi";

const AttachModifierWithGroup = ({
  toBeAttachedModifiers = [],
  setToBeAttachedModifiers = () => {},
  toBeUnLinkModifiers = [],
  setToBeUnLinkModifiers = () => {},
  modifierGroupId = "",
  mode = "edit",
  title = "Attach Modifier",
  subtitle = "Attach Modifier to the group",
  modalTitle = "Attach Modifier",
  modalSubtitle = "Attach Modifier to the group",
}) => {
  const history = useHistory();
  const { t } = useTranslation();
  const [openModal, setOpenModal] = React.useState(false);
  const [modifiers, setModifiers] = React.useState([]);
  const [brandModifiers, setBrandModifiers] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [brandLoading, setBrandLoading] = React.useState(false);
  const [checkedRows, setCheckedRows] = React.useState([]);
  const [updateModal, setUpdateModal] = React.useState(false);
  const [modifier, setModifier] = React.useState(null);
  const [getModifierGroup] = useGetModifierGroupMutation();
  const [getModifierList] = useGetModifierListMutation();

  const { sortModiferGroup, loading: sortLoading } = useGroupModifierApi();

  const getAttachedModifiers = async () => {
    setLoading(true);
    try {
      const userDetail = UTILS.getCurrentUser();
      const { data } = await getModifierGroup({
        brandId: userDetail.brandId,
        modifierGroupId: history?.location?.state?.modifier?._id,
      });
      if (data?.success === 1) {
        const normalizedModifiers = data?.data?.modifiers?.map(
          (modifier) => modifier.modifierId
        );
        setCheckedRows(normalizedModifiers);
        setModifiers(normalizedModifiers);
        setToBeAttachedModifiers(normalizedModifiers);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const getAllBrandModifiers = async () => {
    setBrandLoading(true);
    try {
      const userDetail = UTILS.getCurrentUser();
      const { data } = await getModifierList({
        brandId: userDetail?.brandId,
      });
      if (data?.success === 1) {
        setBrandModifiers(data.data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const removeDuplicateModifiers = (modifiers) => {
    return modifiers.filter(
      (modifier, index, self) =>
        index === self.findIndex((t) => t._id === modifier._id)
    );
  };

  const actionRow = (record) => {
    return (
      <div className="flex gap-2 justify-end px-0 md:ps-3 whitespace-nowrap text-center flex-none ">
        <button
          onClick={() => {
            setUpdateModal(true);
            setModifier(record);
          }}
        >
          <AppIcon name="edit" />
        </button>
        <button
          onClick={() => {
            setToBeAttachedModifiers((prevState) => {
              const newModifiers = prevState.filter(
                (modifier) => modifier._id !== record._id
              );
              return removeDuplicateModifiers(newModifiers);
            });
            setToBeUnLinkModifiers((prevState) => {
              const newModifiers = [...prevState, record];
              return removeDuplicateModifiers(newModifiers);
            });
          }}
        >
          <AppIcon name="trash" />
        </button>
      </div>
    );
  };

  // const mergeUniqueById = (arr1, arr2) => {
  //   const map = new Map();

  //   [...arr1, ...arr2].forEach(item => {
  //     map.set(item._id, item);
  //   });

  //   return Array.from(map.values());
  // };

  // const uniqueModifiers = React.useMemo(() => {
  //   return mergeUniqueById(modifiers, toBeAttachedModifiers);
  // }, [modifiers, toBeAttachedModifiers]);

  React.useEffect(() => {
    if (history?.location?.state?.modifier?._id) {
      getAttachedModifiers();
      getAllBrandModifiers();
    }
  }, [history?.location?.state?.modifier?._id]);

  React.useEffect(() => {
    getAllBrandModifiers();
  }, []);

  return (
    <>
      <AppCollapse
        defaultOpen={toBeAttachedModifiers?.length > 0}
        title={
          <div className="flex items-center justify-between">
            <span>{t(title)}</span>
            <AppButton
              variant="primaryOutline"
              size="md"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setOpenModal(true);
              }}
              // style={{ padding: "0px 20px" }}
            >
              {t("Attach Modifier")}
            </AppButton>
          </div>
        }
        // subtitle={t(subtitle)}
      >
        <ModifierDragger
          modifiers={toBeAttachedModifiers}
          actionButtons={actionRow}
          setModifier={setModifier}
          reOrderCategory={(order) => {
            sortModiferGroup({
              group: order,
              selected: toBeAttachedModifiers?.[order.oldIndex],
              modifierGroupId: modifierGroupId,
              OnSuccess: () => {
                getAttachedModifiers();
              },
            });
          }}
          mode={mode}
        />
      </AppCollapse>
      <AttachModifierModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title={modalTitle}
        subtitle={modalSubtitle}
        modifiers={brandModifiers}
        checkedRows={toBeAttachedModifiers}
        toBeUnLinkModifiers={toBeUnLinkModifiers}
        setToBeUnLinkModifiers={setToBeUnLinkModifiers}
        toBeAttachedModifiers={toBeAttachedModifiers}
        setToBeAttachedModifiers={setToBeAttachedModifiers}
        setModal={setOpenModal}
        onAttachModifiers={(modifiers) => {
          setOpenModal(false);
          setToBeAttachedModifiers(modifiers);
        }}
        onAddNewModifierSuccess={(newModifier) => {
          const newAddedModifier = newModifier?.data?.data;
          getAllBrandModifiers();
          setModifiers([...modifiers, newAddedModifier]);
        }}
      />
      <UpdateModifierModal
        as="modal"
        open={updateModal}
        onClose={() => {
          setUpdateModal(false);
          setModifier(null);
        }}
        selectedModifier={modifier}
        onSuccess={(modifier) => {
          getAttachedModifiers();
          setUpdateModal(false);
          setModifier(null);
        }}
      />
    </>
  );
};

export default AttachModifierWithGroup;
